<template>
    <div id="mask" v-show="show">
        <div id="box" class="window-scale">
            <div id="background">
                <span id="exam-title">隨堂測驗</span>
                <img id="exam-close" src="@/assets/art/paint_board/close.svg" @click="close()">
                <div id="contain">
                    <div id="radios">
                        <span>題數：</span>
                        <label>
                            <input type="radio" value="5" v-model='count'>五題
                        </label>
                        <label>
                            <input type="radio" value="10" v-model='count'>十題
                        </label>
                    </div>
                    <div id="button" @click="setQuestionCount()"> 出題 </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "@/js/event_bus";
import { examStore } from '@/js/store/examStore';
export default {
    name: "LessonExamSelector",
    data: function () {
        return {
            examStore,
            show: false,
            count: 10
        }
    },
    methods: {
        close() {
            this.show = false;
        },
        setQuestionCount() {
            examStore.randomCount = this.count;
            EventBus.getInstance().getAppRefs().lessonExam.setRandomExam();
            EventBus.getInstance().getAppRefs().lessonExam.setExamPath();
            EventBus.getInstance().getAppRefs().lessonExam.show = true;

            this.close();
        }
    }
}
</script>

<style scoped>
#mask {
    z-index: var(--z-index-lesson-exam);
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

#box {
    position: absolute;
    left: 50%;
    top: 50%;
}

#background {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    width: 400px;
    height: 200px;
    background-color: rgb(28, 106, 188);
}

#exam-title {
    position: absolute;
    transform: translateX(-50%);
    font-size: 20px;
    font-weight: bold;
    color: white;
}

#exam-close {
    position: absolute;
    right: 10px;
    top: 5px;
    width: 17px;
    color: white;
}

#contain {
    position: absolute;
    transform: translate(-50%, 0);
    left: 50%;
    bottom: 10px;
    width: 380px;
    height: 160px;
    border-radius: 5px;
    background-color: rgb(255, 255, 255);
}

#radios {
    position: absolute;
    transform: translateX(-50%);
    top: 30px;
    left: 50%;
}

#button {
    position: absolute;
    width: 110px;
    height: 30px;
    background-color: rgb(28, 106, 188);
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    line-height: 30px;
    color: white;
    border-radius: 5px;
}
</style>